import { render, staticRenderFns } from "./EternityMilestoneButton.vue?vue&type=template&id=6937e6e4&scoped=true&"
import script from "./EternityMilestoneButton.vue?vue&type=script&lang=js&"
export * from "./EternityMilestoneButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6937e6e4",
  null
  
)

export default component.exports